import { Routes, Route } from "react-router-dom";
import Home from "./router/Home";
import Contact from "./router/Contact";
import About from "./router/About";
import Nav from "./components/Nav";

function App() {

  return (
    <div className="App">
    <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
      </Routes>
    </div>
  );
}

export default App;
